<template>
    <div class="flex pt-1 pb-2">
        <div class="flex-shrink text-xs flex">
            <span class="self-start mt-1 pr-1"><i class="fa fa-quote-left"/></span>
        </div>
        <div
            class="flex-grow bg-gray-100 border rounded-lg border-gray-300 text-xs text-gray-600 px-2 py-1 hover:text-brand cursor-pointer"
            @click="$emit('click',message)">
            <div class="font-bold">{{ message.from }}</div>
            <div v-html="message.message"></div>
        </div>
        <div class="flex-shrink text-xs flex">
            <span class="self-end mb-1 pl-1"><i class="fa fa-quote-right"/></span>
        </div>
    </div>
</template>

<script>

export default {
    components: {},
    props: {
        message: Object,
    },
    data() {
        return {}
    },
    computed: {},
    methods: {}
}
</script>
